import React from 'react';
import { EmailVerificationResultProps } from '../../organisms/EmailVerificationResult/EmailVerificationResult';
import EmailVerificationResult from '../../organisms/EmailVerificationResult';

const ConfirmEmailChange = (props: EmailVerificationResultProps): JSX.Element => (
  <EmailVerificationResult {...props} />
);

export default ConfirmEmailChange;
